/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { BsCalendar3, BsFillChatLeftTextFill } from "react-icons/bs";

const blogsData = [
  {
    img: "https://miro.medium.com/v2/resize:fit:502/1*KI1_0g6Dlz3m8_QKkTZ2qw.jpeg",
    title: "Some discussion about React.",
    description: "What is JSX?, What is npm?, What is React routers?, Default Props., What is Virtual DOM?",
    type: ["programing", "coding"],
    date: "Nov 4, 2020",
    commentsCount: "05",
    link: "https://mahbub-hasan.medium.com/why-should-we-use-react-dc194b4c7a27",
  },
  {
    img: "https://miro.medium.com/max/700/1*U7f_zyAMRT_3uR2cRy3llA.jpeg",
    title: "Intermediate JavaScript Interview Questions.",
    description: "double equal vs triple equal, Null Vs Undefined, Block Scope, Apply map, filter, find on an array of objects.",
    type: ["programing"],
    date: "Nov 5, 2020",
    commentsCount: "05",
    link: "https://mahbub-hasan.medium.com/intermediate-javascript-interview-questions-d83626f07a5a",
  },
  {
    img: "https://miro.medium.com/max/700/1*ZRV92399sgFGeWbzcAHjig.jpeg",
    title: "What I learned today about JavaScript:",
    description: "Coding Style, Best practice of comments, Client-side caching, Client-side Catch, Server-side caching",
    type: ["programing", "coding"],
    date: "26 Feb 2020",
    commentsCount: "05",
    link: "/",
  },
  {
    img: "https://miro.medium.com/max/700/1*ZKknAq-txt7tTTYXWgk7CA.jpeg",
    title: "JAVASCRIPT FUNDAMENTAL CONCEPTS",
    description: "indexOf, push, Pop, Length, Shif, Math.ceil",
    type: ["programing", "coding"],
    date: "26 Feb 2020",
    commentsCount: "05",
    link: "/",
  },
];

const Blogs = () => {
  return (
    <div className="grid grid-cols-1 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2">
      {blogsData.map((blog, i) => (
        <div key={i} className="w-full px-4">
          <div className="mx-auto mb-10 max-w-[370px]">
            <div className="mb-8 overflow-hidden rounded">
              <img src={blog.img} alt="image blog" className="w-full" />
            </div>
            <div>
              {blog.type.map((item, i) => (
                <span
                  key={i}
                  className="mb-3 px-1.5 inline-block text-sm font-bold font-inter text-primary"
                >
                  {item}
                </span>
              ))}
              <h3>
                <a
                  href={blog.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark hover:text-primary mb-4 inline-block text-xl font-poppins font-semibold sm:text-2xl lg:text-xl xl:text-2xl"
                >
                  {blog.title}
                </a>
              </h3>
              <div className="flex text-gray-400 gap-6">
                <p className="flex text-sm">
                  <BsCalendar3 className="h-full" />
                  <span className="ml-2 font-semibold">{blog.date}</span>
                </p>
                <p className="flex text-sm">
                  <BsFillChatLeftTextFill className="h-full" />
                  <span className="ml-2 font-semibold">
                    {blog.commentsCount}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Blogs;
